import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="The Art of Readable Code by Dustin Boswell and Trevor Foucher"
        desc="Simple and practical techniques for writing better code"
        keyword="art of readable code, dustin boswell, trevor foucher, clean code, readability, code quality"
        image="/images/books/the-art-of-readable-code.jpg"
        pageType="book"
        author="Dustin Boswell, Trevor Foucher"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/the-art-of-readable-code.jpg"
                alt="the art of readable code dustin boswell trevor foucher engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                The Art of Readable Code
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Dustin Boswell, Trevor Foucher</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Dustin Boswell and Trevor Foucher distill years of experience into practical,
                immediately applicable techniques for writing code that others (and your future
                self) can easily understand. The book covers everything from choosing good names
                and writing clear comments to simplifying loops, breaking down large expressions,
                and reorganizing code for clarity.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                What sets this book apart is its focus on the reader's experience. Every
                technique is grounded in a simple principle: code should be written to minimize
                the time it takes someone else to understand it. Packed with before-and-after
                examples across multiple languages, it's an essential read for any engineer who
                wants to write code that is a pleasure to work with.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
